<template>
  <a-modal
    class="client-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    :footer="null"
    :title="title"
    @cancel="$emit('onCancel')"
  >
    <a-form
      layout="horizontal"
      :form="form"
      style="margin-bottom:90px;"
    >
      <a-form-item
        label="题目类型"
        :colon="false"
        :label-col="{span:5}"
        :wrapper-col="{span:17}"
      >
        <a-select
          v-decorator="[
            'type',
            { rules: [{ required: true, message: '请选择题目类型' }],initialValue:'0' },

          ]"
          placeholder="请选择题目类型"
          :disabled="selectIsDisabled"
          @change="changeSelect"
        >
          <a-select-option
            v-for="item in questionType"
            :key="item.key"
            :value="item.key"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="题目标题"
        :colon="false"
        :label-col="{span:5}"
        :wrapper-col="{span:17}"
      >
        <a-textarea
          v-decorator="[
            'question',
            {
              rules: [
                {
                  required: true,
                  message: '请输入题目标题',
                },
              ],
            },
          ]"
          placeholder="请输入题目标题"
        />
      </a-form-item>
      <template v-if="type==='1'||type==='2'">
        <a-form-item
          v-for="(item,index) in questionData.options"
          :key="item.key"
          :colon="false"
          :label="`问题选项${index+1}`"
          :label-col="{span:5}"
          :wrapper-col="{span:17}"
        >
          <a-input
            v-decorator="[
              `${item.key}.value`,
              {
                rules: [
                  {
                    required: true,
                    message: '请输入问题选项',
                  },
                ],
              },
            ]"
            placeholder="请输入问题选项"
            style="width: 92%; margin-right: 8px"
          />
          <a-icon
            v-if="questionData.options.length > 1 "
            class="question-delete-button"
            type="minus-circle-o"
            :disabled="questionData.options.length === 1 "
            @click="() => remove(index)"
          />
        </a-form-item>
      </template>
      <a-form-item
        v-if="type==='1'||type==='2'"
        :colon="false"
        :wrapper-col="{span:17,offset:5}"
      >
        <a-button
          type="dashed"
          style="width: 60%"
          @click="add"
        >
          <a-icon type="plus" /> 增加项
        </a-button>
      </a-form-item>
    </a-form>
    <slot />
  </a-modal>
</template>
<script>
const uuidv1 = require('uuid/v1');
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    selectIsDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
		productData:[],
      questionType: [
        {key: '0', name: '问答题'},
        {key: '1', name: '单选题'},
        {key: '2', name: '多选题'},
      ],
      type: '',
      questionData: {
        options: [
          {key: uuidv1(), value: ''},
        ],
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted() {
  	// 获取产品
  	this.getProduct();
  },
  methods: {
	  // 获取合作企业
	  async getProduct() {
	    let result = await this.$http.post('/product/getList');
	    if (result.data.status === 1) {
	      this.productData = result.data.data.data_list;
	    }
	  },
    initData(){
      this.questionData = {options: [
        {key: uuidv1(), value: ''},
      ]};
      this.type = '';
    },
    updateData(options, type){
      this.questionData = {options: JSON.parse(JSON.stringify(options))};
      this.type = type;
    },
    remove(key){
      this.questionData.options = this.questionData.options.filter((item, index)=>index !== key);
      console.log('remove -> this.questionData.options', this.questionData.options);
    },
    add(){
      console.log(1111);
      this.questionData.options.push({ key: uuidv1(), value: ''});
      this.questionData = JSON.parse(JSON.stringify( this.questionData));
      console.log('TCL: add -> this.questionData', this.questionData);
    },
    // 下拉框选择
    changeSelect(key){
      this.type=key;
      this.questionData={
        type: key,
        question: '',
        options: [{key: uuidv1(),  value: ''}],
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.question-delete-button {
  cursor: pointer;
  position: relative;
 top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.question-delete-button:hover {
  color: #777;
}
.question-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
